import { TreeIncludeExcludeFilter } from '../../CustomFilterComponents/TreeIncludeExcludeFilter';
import type { FilterConfigSubGroupItem } from '../FilterConfigTypes';

export const IABTreeFilter = (
  <TreeIncludeExcludeFilter
    dictionary="IAB"
    filterName="moments_iab_taxonomy_id"
    decileFilterName="moments_iab_decile"
    recencyFilterName="moments_recency_filter"
  />
);
export const MeshTreeFilter = (
  <TreeIncludeExcludeFilter
    dictionary="MeSH"
    filterName="moments_mesh_taxonomy_id"
    decileFilterName="moments_mesh_decile"
    recencyFilterName="moments_recency_filter"
  />
);

export const throtleSubGroupItems: Array<FilterConfigSubGroupItem> = [
  {
    groupLabelId: 'iab_subgroup',
    parentGroupLabel: 'Moments',
    groupLabel: 'IAB',
    ordinalPosition: 10,
    tooltip:
      'Specify the IAB (Interactive Advertising Bureau) Descriptor to refine your audience. This filter allows you to target healthcare professionals based on their digital behavior and interests, as categorized by the IAB, ensuring your outreach is aligned with their online preferences and activities.',
    filtersInGroup: [
      { name: 'moments_iab_taxonomy_id', index: 1 },
      { name: 'moments_recency_filter', index: 2 },
      { name: 'moments_iab_decile', index: 3 },
    ],
    icon: 'Iab',
    customComponent: IABTreeFilter,
  },
  {
    groupLabelId: 'mesh_subgroup',
    parentGroupLabel: 'Moments',
    groupLabel: 'MeSH',
    ordinalPosition: 10,
    tooltip:
      'Specify the MesH Descriptor to refine your audience. This filter allows you to target healthcare professionals based on their digital behavior and interests, as categorized by the Mesh, ensuring your outreach is aligned with their online preferences and activities.',
    filtersInGroup: [
      { name: 'moments_mesh_taxonomy_id', index: 1 },
      { name: 'moments_recency_filter', index: 2 },
      { name: 'moments_mesh_decile', index: 3 },
    ],
    icon: 'Endemics',
    customComponent: MeshTreeFilter,
  },
];
